import { whenAll } from 'platform/shared/health-apps';
import content from '../../../locales/en/content.json';
import {
  hasDifferentMailingAddress,
  hasNoSharedAddress,
  hasSecondaryCaregiverOne,
} from '../../../utils/helpers';
import addressSelection from './addressSelection';
import contactInformation from './contactInformation';
import hasSecondary from './hasSecondary';
import homeAddress from './homeAddress';
import identityInformation from './identityInformation';
import mailingAddress from './mailingAddress';
import personalInformation from './personalInformation';

export const secondaryOnePages = {
  hasSecondaryOne: {
    path: 'secondary-caregiver/apply-for-benefits',
    title: content['secondary-info-title--apply'],
    ...hasSecondary,
  },
  secondaryOnePersonalInfo: {
    path: 'secondary-caregiver/personal-information',
    title: content['secondary-one-info-title--personal'],
    depends: hasSecondaryCaregiverOne,
    ...personalInformation,
  },
  secondaryOneIdentityInfo: {
    path: 'secondary-caregiver/identity-information',
    title: content['secondary-one-info-title--id'],
    depends: hasSecondaryCaregiverOne,
    ...identityInformation,
  },
  secondaryOneAddressSelection: {
    path: 'secondary-caregiver-address-selection',
    title: content['secondary-one-address--selection-title'],
    depends: hasSecondaryCaregiverOne,
    ...addressSelection,
  },
  secondaryOneHomeAddress: {
    path: 'secondary-caregiver/home-address',
    title: content['secondary-one-info-title--address-home'],
    depends: whenAll(
      hasSecondaryCaregiverOne,
      hasNoSharedAddress('secondaryOne'),
    ),
    ...homeAddress,
  },
  secondaryOneMailingAddress: {
    path: 'secondary-caregiver/mailing-address',
    title: content['secondary-one-info-title--address-mailing'],
    depends: whenAll(
      hasSecondaryCaregiverOne,
      hasDifferentMailingAddress('secondaryOne'),
    ),
    ...mailingAddress,
  },
  secondaryOneContactInfo: {
    path: 'secondary-caregiver/contact-information',
    title: content['secondary-one-info-title--contact'],
    depends: hasSecondaryCaregiverOne,
    ...contactInformation,
  },
};
